import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import Ad from '@ifeng/ui_pc_ad';
import errorBoundary from '@ifeng/errorBoundary';
import SiderTopic from '../../../components/siderTopic';
import AutoTitle from './autoTitle';
import AutoList from './autoList';
import AutoBtn from './autoBtn';
import AutoSearch from './autoSearch';
import IpadAd from '../../../components/ipadAd';

class AENewsSider extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: {
                aeNewsSiderTitle,
                aeNewsSiderContent0,
                aeNewsSiderContent1,
                aeNewsSiderContent2,
                autoAndEntSiderAd,
                ipadAd1,
            },
        } = this.props;

        return (
            <div className={styles.sider_box}>
                <Chip
                    id="50065"
                    type="struct"
                    title="汽车娱乐要闻区左侧栏标题"
                    groupName="汽车娱乐要闻区左侧栏"
                    content={aeNewsSiderTitle}>
                    <SiderTopic />
                </Chip>
                <Chip
                    id="50067"
                    type="struct"
                    title="汽车娱乐要闻区左侧栏编辑区1"
                    groupName="汽车娱乐要闻区左侧栏"
                    content={aeNewsSiderContent0}>
                    <AutoTitle />
                </Chip>
                <Chip
                    id="50091"
                    type="struct"
                    title="汽车娱乐要闻区左侧栏编辑区2"
                    groupName="汽车娱乐要闻区左侧栏"
                    content={aeNewsSiderContent1}>
                    <AutoList />
                </Chip>
                <Chip
                    id="50068"
                    type="struct"
                    title="汽车娱乐要闻区左侧栏编辑区3"
                    groupName="汽车娱乐要闻区左侧栏"
                    content={aeNewsSiderContent2}>
                    <AutoBtn />
                </Chip>
                <AutoSearch />
                <NoSSR>
                    {autoAndEntSiderAd ? (
                        <Ad content={autoAndEntSiderAd} />
                    ) : (
                        <Chip id="40103" type="static" title="广告2" groupName="汽车娱乐要闻区左侧栏" content={ipadAd1}>
                            <IpadAd />
                        </Chip>
                    )}
                </NoSSR>
            </div>
        );
    }
}

export default errorBoundary(AENewsSider);
